import { changeProp } from 'modules/contractSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useContractList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useSelector(({ contract }) => contract);

  const onChange = e => {
    const { name, value } = e.target;
    dispatch(changeProp({ key: name, value }));
  };

  const onMove = () => {
    navigate('creator');
  };

  return { search, onChange, onMove };
};

export default useContractList;
